import auth from 'auth/logic/auth';

function verifyAndLoadUser(deps, model, login, password, acceptTerms, registrationForm = true) {
  let decodedLogin = '';
  let decodedPassword = '';

  try {
    decodedLogin = window.atob(login);
    decodedPassword = password;
  } catch (e) {
    decodedLogin = login;
    decodedPassword = password;
  }

  return auth.login(
    deps,
    model,
    {
      email: decodedLogin,
      password: decodedPassword,
    },
    acceptTerms,
    registrationForm
  );
}
export default { verifyAndLoadUser };



// WEBPACK FOOTER //
// ./src/modules/registration/logic/registration.js